import "./AnonymousModeBanner.scss";
import * as strings from "../../../strings";
import React, { useCallback, useRef } from "react";
import Text from "../../common/Text/Text";
import { useFlag } from "../../../lib/hook/MiscHooks";
import * as Flags from "../../../lib/Flags";
import clsx from "clsx";
import { FaChartBar, FaUserSecret } from "react-icons/fa";
import Button from "../../common/Button/Button";
import * as NavigationUtils from "../../../lib/util/NavigationUtils";
import * as Utils from "../../../lib/util/Utils";

const AnonymousModeBanner = () => {
	const shownRef = useRef(false);
	const anonymousMode = useFlag(Flags.ANONYMOUS_MODE);
	const demoMode = useFlag(Flags.DEMO_MODE);

	const handleExit = useCallback(() => {
		const currentRoute = NavigationUtils.getCurrentRoute();
		if (demoMode.is()) {
			if (currentRoute?.id === "driverProfile") {
				NavigationUtils.go("/drivers");
			}

			Utils.nextFrame(() => demoMode.toggle());
		} else {
			anonymousMode.toggle();
		}
	}, [anonymousMode, demoMode]);

	if (anonymousMode.is()) {
		shownRef.current = true;
	}

	return shownRef.current ? (
		<div
			className={clsx("AnonymousModeBanner", anonymousMode.is() && "--visible")}
		>
			<div className={"AnonymousModeBanner__content"}>
				<div className={"--row"}>
					<div className={"AnonymousModeBanner__icon"}>
						{demoMode.is() ? <FaChartBar /> : <FaUserSecret />}
					</div>
					<Text textAlign={"start"}>
						{demoMode.is()
							? strings.STATUS_BAR_DEMO_MODE
							: strings.STATUS_BAR_ANONYMOUS_MODE}
						{".  "}
					</Text>
				</div>
				<Button
					className={"AnonymousModeBanner__exit --light --outlined --small"}
					onClick={handleExit}
				>
					{strings.MISC_EXIT}
				</Button>
			</div>
		</div>
	) : null;
};

export default AnonymousModeBanner;
